import { Ref } from "react";
import styled from "styled-components";
import { TitleWrapper, TitleText, StyledButton, ButtonRow } from "../../../shared/styled/TitleBar";

const DeliveryTitle = styled(TitleWrapper)`
    flex-wrap: wrap;
    gap: 12px;
`;
const DeliveryActions = styled(ButtonRow)`
    flex-wrap: wrap;
    button { white-space: nowrap; flex-shrink: 0; }
`;

const Title = ({ handleExport, handleReport, activeTab = "list", actionsRef }: {
    handleExport: () => void;
    handleReport: () => void;
    activeTab?: string;
    actionsRef: Ref<HTMLDivElement>;
}) => (
    <DeliveryTitle data-testid="delivery-title">
        <TitleText>Danh sách chuyến vận chuyển</TitleText>
        <DeliveryActions ref={actionsRef} role="group" aria-label="Thao tác vận chuyển">
            {activeTab === "list" && <>
                <StyledButton variant="text" onClick={handleReport}>Xuất báo cáo</StyledButton>
                <StyledButton variant="contained" onClick={handleExport}>Xuất hóa đơn</StyledButton>
            </>}
        </DeliveryActions>
    </DeliveryTitle>
);

export default Title;
